import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Check } from "lucide-react";
import { cn } from "../../../lib/utils";
import { useNavigate } from "react-router-dom";
import { pricingPlans } from "../../../data/kundaliMatchingPlans";
import { trackReportEvent } from "../../../utils/analytics";



const PricingSection = () => {
  const navigate = useNavigate();

  const handleBuyNow = (plan) => {
    
    trackReportEvent("select", {
      reportName: plan.title,
      reportId: plan.id,
      price: plan.price,
    });
    
    navigate(`/kundali-matching-report/${plan.id}`);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-muted_km to-background_km">
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground_km mb-8">
            Why Match Your Kundli?
          </h2>
          <p className="text-lg text-muted_km-foreground mb-12 max-w-4xl mx-auto">
            Vedic astrology views marriage as a union of souls. Matching your Kundli (birth charts) helps you:
          </p>
          
          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
            <div className="flex items-start space-x-3 p-4 bg-card_km rounded-lg">
              <div className="w-6 h-6 bg-primary_km rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-4 h-4 text-primary-foreground_km" fill="#fff" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="font-semibold text-foreground_km mb-1">Check compatibility across 36 Gunas</h3>
                <p className="text-sm text-muted_km-foreground">आपकी भावनात्मक, मानसिक और शारीरिक सामंजस्य का आकलन करें।</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 p-4 bg-card_km rounded-lg">
              <div className="w-6 h-6 bg-primary_km rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-4 h-4 text-primary-foreground" fill="#fff" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="font-semibold text-foreground_km mb-1">Predict stability and well-being</h3>
                <p className="text-sm text-muted_km-foreground">संभावित वित्तीय और भावनात्मक ताकत या चुनौतियों को समझें।</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 p-4 bg-card_km rounded-lg">
              <div className="w-6 h-6 bg-primary_km rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-4 h-4 text-primary_km-foreground_km" fill="#fff" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="font-semibold text-foreground_km mb-1">Identify doshas and remedies</h3>
                <p className="text-sm text-muted_km-foreground">मांगल, भकूट, नाड़ी और अन्य दोषों का पता लगाएँ और उन्हें दूर करने के उपाय जानें।</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3 p-4 bg-card_km rounded-lg">
              <div className="w-6 h-6 bg-primary_km rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <svg className="w-4 h-4 text-primary-foreground_km" fill="#fff" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="text-left">
                <h3 className="font-semibold text-foreground_km mb-1">Path for Successful Marriage</h3>
                <p className="text-sm text-muted_km-foreground">शांतिपूर्ण, सुखमय और समृद्ध वैवाहिक जीवन की मजबूत नींव स्थापित करें।</p>
              </div>
            </div>
          </div>

          <p className="text-lg text-muted_km-foreground mb-12 max-w-4xl mx-auto">
            Acharya Lav Bhushan’s report goes beyond basic horoscope matching, delving into personality traits, emotional compatibility and potential life obstacles to give you a holistic picture.
          </p>

        </div>

        {/* Pricing Section */}
        <div id="pricing-section" className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-foreground_km mb-4">
            Choose Your Package That's Right For You
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Basic Package */}
          <Card className="relative border border-primary_km shadow_km-lg hover:border-primary_km/30 transition-all duration-300">
            <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-destructive_km text-destructive_km-foreground">
              {pricingPlans[0].badge}
            </Badge>
            <CardHeader className="text-center pb-4">
              <CardTitle className="text-2xl mb-2">{pricingPlans[0].title}</CardTitle>
              <p className="text-sm text-muted_km-foreground mb-4">
                {pricingPlans[0].subtitle}
              </p>
              
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[0].features[0] }} />
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">{pricingPlans[0].features[1]}</span>
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">{pricingPlans[0].features[2]}</span>
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">{pricingPlans[0].features[3]}</span>
              </div>
              <div className="space-y-1">
                <div className="text-sm text-muted_km-foreground line-through">{pricingPlans[0].priceOriginal}</div>
                <div className="text-4xl font-bold text-primary_km">{pricingPlans[0].priceFinal}</div>
              </div>
                <Button onClick={() => handleBuyNow(pricingPlans[0])} variant="astrology" className="w-full mt-6">
                  BUY NOW
                </Button>
              
            </CardContent>
          </Card>

          {/* Premium Package */}
          <Card className="relative border-2 border-primary_km shadow_km-lg scale-105 hover:scale-110 transition-all duration-300">
            <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary_km text-primary_km-foreground">
              {pricingPlans[1].badge}
            </Badge>
            <CardHeader className="text-center pb-4">
              <CardTitle className="text-2xl mb-2">{pricingPlans[1].title}</CardTitle>
              <p className="text-sm text-muted_km-foreground mb-4">
                {pricingPlans[1].subtitle}
              </p>
              
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[1].features[0] }} />
              </div>
              
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[1].features[1] }} />
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[1].features[2] }} />
              </div>
             <div className="space-y-1">
                <div className="text-sm text-muted_km-foreground line-through">{pricingPlans[1].priceOriginal}</div>
                <div className="text-4xl font-bold text-primary_km">{pricingPlans[1].priceFinal}</div>
              </div>
                <Button onClick={() => handleBuyNow(pricingPlans[1])} variant="astrology" className="w-full mt-6">
                  BUY NOW
                </Button>
             
            </CardContent>
          </Card>

          {/* Budget Package */}
          <Card className="relative border border-primary_km shadow_km-lg hover:border-primary_km/30 transition-all duration-300">
            <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-secondary_km text-secondary_km-foreground">
              {pricingPlans[2].badge}
            </Badge>
            <CardHeader className="text-center pb-4">
              <CardTitle className="text-2xl mb-2">{pricingPlans[2].title}</CardTitle>
              <p className="text-sm text-muted_km-foreground mb-4">
                {pricingPlans[2].subtitle}
              </p>
              
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[2].features[0] }} />
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm" dangerouslySetInnerHTML={{ __html: pricingPlans[2].features[1] }} />
              </div>
              <div className="flex items-start space-x-2">
                <svg className="w-5 h-5 text-primary_km mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span className="text-sm">{pricingPlans[2].features[2]}</span>
              </div>
              <div className="space-y-1">
                <div className="text-sm text-muted_km-foreground line-through">{pricingPlans[2].priceOriginal}</div>
                <div className="text-4xl font-bold text-primary_km">{pricingPlans[2].priceFinal}</div>
              </div>
                <Button onClick={() => handleBuyNow(pricingPlans[2])} variant="astrology" className="w-full mt-6">
                  BUY NOW
                </Button>
              
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;